import * as React from 'react';
import {
  SiCalendly,
  SiConfluence,
  SiGithub,
  SiGmail,
  SiGooglecalendar,
  SiGoogledrive,
  SiHubspot,
  SiJira,
  SiLinkedin,
  SiNotion,
  SiSalesforce,
  SiSlack
} from 'react-icons/si';
import { TbApi, TbDatabase, TbMailFilled, TbBrandOffice } from 'react-icons/tb';

// Using React Icons for official brand logos
// These are tree-shaken automatically, so only imported icons are included in the bundle
export const IntegrationLogos = {
  Slack: ({ className }: { className?: string }) => (
    <SiSlack className={`${className || 'h-full w-full'} text-[#4A154B]`} />
  ),

  Gmail: ({ className }: { className?: string }) => (
    <SiGmail className={`${className || 'h-full w-full'} text-[#EA4335]`} />
  ),

  Outlook: ({ className }: { className?: string }) => (
    <TbMailFilled className={`${className || 'h-full w-full'} text-[#0078D4]`} />
  ),

  GoogleCalendar: ({ className }: { className?: string }) => (
    // Official Google Calendar mark (multi-color "31" calendar) from simple-icons.
    // logo.dev returns the generic Google "G" for every google subdomain so we
    // use the brand-faithful SVG here instead of a downloaded PNG.
    <SiGooglecalendar className={`${className || 'h-full w-full'}`} />
  ),

  Calendly: ({ className }: { className?: string }) => (
    <SiCalendly className={`${className || 'h-full w-full'} text-[#006BFF]`} />
  ),

  Salesforce: ({ className }: { className?: string }) => (
    <SiSalesforce className={`${className || 'h-full w-full'} text-[#00A1E0]`} />
  ),

  HubSpot: ({ className }: { className?: string }) => (
    <SiHubspot className={`${className || 'h-full w-full'} text-[#FF7A59]`} />
  ),

  LinkedIn: ({ className }: { className?: string }) => (
    <SiLinkedin className={`${className || 'h-full w-full'} text-[#0A66C2]`} />
  ),

  CustomAPI: ({ className }: { className?: string }) => (
    <TbApi className={`${className || 'h-full w-full'} text-[#7F56D9]`} />
  ),

  SQL: ({ className }: { className?: string }) => (
    <TbDatabase className={`${className || 'h-full w-full'} text-[#336791]`} />
  ),

  GitHub: ({ className }: { className?: string }) => (
    <SiGithub className={`${className || 'h-full w-full'} text-[#181717]`} />
  ),

  Jira: ({ className }: { className?: string }) => (
    <SiJira className={`${className || 'h-full w-full'} text-[#0052CC]`} />
  ),

  Confluence: ({ className }: { className?: string }) => (
    <SiConfluence className={`${className || 'h-full w-full'} text-[#0052CC]`} />
  ),

  Notion: ({ className }: { className?: string }) => (
    <SiNotion className={`${className || 'h-full w-full'} text-[#000000]`} />
  ),

  GoogleDrive: ({ className }: { className?: string }) => (
    <SiGoogledrive className={`${className || 'h-full w-full'} text-[#4285F4]`} />
  ),

  SharePoint: ({ className }: { className?: string }) => (
    <TbBrandOffice className={`${className || 'h-full w-full'} text-[#0078D4]`} />
  ),

  // Attio has no react-icons entry. Render the wordmark in their signature
  // tight black sans — close enough to read as a logo in a grid cell.
  Attio: ({ className }: { className?: string }) => (
    <span
      className={`${className || ''} inline-flex items-center justify-center font-semibold tracking-[-0.02em] text-[#1A1A1A] dark:text-[#F2F2EE] text-[clamp(18px,2.4vw,26px)] leading-none`}
    >
      Attio
    </span>
  ),

  // Model Context Protocol — render the official mark (downloaded from
  // modelcontextprotocol.io via logo.dev) ALONGSIDE the "MCP" wordmark, so
  // the cell reads as MCP-branded both visually AND by name. The full
  // "Model Context Protocol" wordmark would overflow the narrow cell.
  // eslint-disable-next-line @next/next/no-img-element
  MCP: ({ className }: { className?: string }) => (
    <span
      className={`${className || ''} inline-flex items-center justify-center gap-2`}
    >
      <img
        src="/assets/integrations/mcp.png"
        alt=""
        className="h-7 w-7 object-contain shrink-0"
      />
      <span className="font-semibold tracking-[-0.02em] text-[#1A1A1A] dark:text-[#F2F2EE] text-[clamp(15px,2vw,20px)] leading-none">
        MCP
      </span>
    </span>
  )
};
